var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
var Divider = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  margin: 0.25rem 0;\n"], ["\n  border: 1px solid ", ";\n  margin: 0.25rem 0;\n"])), function (p) { return p.theme.colorContentAreaBorder; });
export default Divider;
var templateObject_1;
